import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "../../Assets/Css/HomeCss/header.css";
// import ProfileImg from "./ProfileImg";
import { useTranslation } from "react-i18next";
// import SelelctLang from "./SelelctLang";
import "../../Assets/Css/HomeCss/topbar.css";
import TopBar from "../TopBar";

const Header = () => {
  const { t } = useTranslation();
  const [Toggle, setToggle] = useState(false);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (Toggle && !event.target.closest('.menu') && !event.target.closest('.menu_mobile')) {
        setToggle(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [Toggle]);

  // Close mobile menu when window is resized to desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && Toggle) {
        setToggle(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [Toggle]);

  return (
    <div>
      <TopBar/>
      <header className="header posit_rela">
        <div className="Header_container _container">
          <div className="logo_siz">
            <Link to={"/"}>
              <img src="/img/final-logo.png" className="logo_nav" alt="Famra Cure" />
            </Link>
            <div className="menu_mobile">
              <button
                className="btn_menu"
                aria-label={Toggle ? "Close menu" : "Open menu"}
                onClick={(e) => {
                  e.stopPropagation();
                  setToggle(!Toggle);
                }}
              >
                <i className={Toggle ? "fa-regular fa-xmark-large" : "fa-light fa-bars"}></i>
              </button>
            </div>
          </div>
          <nav className={Toggle ? "shaw menu" : "menu"}>
            <ul className="nav_items">
              <li className="nav_item">
                <NavLink to={"/"} end className="nav_link">
                  {t("Header.Home")}
                </NavLink>
              </li>
              <li className="nav_item">
                <NavLink to={"/search-doctor"} className={"nav_link"}>
                  {t("Header.Find_Doctor")}
                </NavLink>
              </li>
              <li className="nav_item">
                <NavLink to={"/about"} className="nav_link">
                  {t("Header.About")}
                </NavLink>
              </li>
              <li className="nav_item">
                <NavLink to={"/contact"} className={"nav_link"}>
                  {t("Header.Contact")}
                </NavLink>
              </li>

              {/* <li className="nav_item">
                <Link to={"/blogs"} className={"nav_link"}>
                  {t("Header.blogs")}
                </Link>
              </li> */}
              {/* Commented out or removed Login/Register buttons */}
              {/* <li className="nav_item">
                <Link to={"/login"} className="nav_link">
                  {t("Header.Login")}
                </Link>
              </li>
              <li className="nav_item">
                <Link to={"/register"} className="nav_link">
                  {t("Header.Register")}
                </Link>
              </li> */}
            </ul>
            {/* <ProfileImg /> */}
            {/* <SelelctLang /> */}
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
